(function () {
    "use strict";

    var CurrencyPairParameterControl = Solovis.defineClass(
        "Solovis.Reports.Parameters.CurrencyPairParameterControl",
        Solovis.UI.BaseControl,
        function (options) {
            this.initialParameterValue = (typeof options.initialValue != "undefined") ? options.initialValue : null;
            this.currentCurrencyPair = this.initialParameterValue;
        });


    CurrencyPairParameterControl.preload = function (newValue, callback) {
        if (newValue && newValue.id) {            
            Solovis.Reports.ReportDataLoader.loadDataSetAsync("/Solovis/Metadata/ParameterLoad", 
                { currencyPair: { id: newValue.id } },                           
                function (response, success) {                    
                    if (success) {
                        var dataSet = response.result.dataSet;
                        var currencyPairData = dataSet.currencyPair ? dataSet.currencyPair : null;
                        callback(currencyPairData, true);                        
                    }
                    else {
                        callback(null, false);
                    }
                });
        }
        else {
            callback(null, true);
        }
    };

    CurrencyPairParameterControl.serializeParameterValue = function (value) {
        if (value) {
            if (value.id) {
                return { id: value.id };
            }
        }

        return null;
    };

    CurrencyPairParameterControl.getLabel = function (value) {
        return value?.label
    };

    CurrencyPairParameterControl.prototype.doInit = function () {
    };

    CurrencyPairParameterControl.prototype.doRender = function () {
        var self = this;

        this.selectedCurrencyPairLabel = $("<span>").appendTo(this.container);
        this.selectCurrencyPairLink = $("<a>").html("<span class='fa fa-pencil'></span>").appendTo(this.container);

        this.selectCurrencyPairLink.click(function () {
            self._toggleSelectorDialog(function (currencyPair) {
                self._setCurrentCurrencyPairData(currencyPair);
                self.notifyParameterValueChanged();
            });
        });

        // Set initial parameter value text.
        if (this.currentCurrencyPair) {
            this._setCurrentCurrencyPairData(this.currentCurrencyPair);
        }
    };

    CurrencyPairParameterControl.prototype._setCurrentCurrencyPairData = function (currencyPairData) {
        this.currentCurrencyPair = currencyPairData;
        if (this.currentCurrencyPair) {
            this.selectedCurrencyPairLabel.text(CurrencyPairParameterControl.getLabel(this.currentCurrencyPair) + " ");
        }
        else {
            this.selectedCurrencyPairLabel.text("");
        }
    };

    CurrencyPairParameterControl.prototype.setParameterValue = function (newValue) {
        this._setCurrentCurrencyPairData(newValue);
    };

    CurrencyPairParameterControl.prototype.getParameterValue = function () {
        if (this.state < Solovis.UI.BaseControl.ControlState.afterInit) {
            return this.initialParameterValue ? this.initialParameterValue : null;
        }
        else if (this.currentCurrencyPair) {
            return Solovis.deepCopy(this.currentCurrencyPair);
        }
        else {
            return null;
        }
    };

    CurrencyPairParameterControl.prototype.notifyParameterValueChanged = function () {
        $(this).trigger("parameterValueChanged");
    };


    CurrencyPairParameterControl.prototype._toggleSelectorDialog = function (selectionCallback) {
        var self = this;

        if (this._selectionDialog) {
            // We already have the selection dialog open, so close it.
            this._selectionDialog.close();
            this._selectionDialog = null;
            return;
        }


        var selectorControlHostDiv = $("<div>");
        var selectorControlHost = new Solovis.UI.ControlHost({ container: selectorControlHostDiv });
        var selectorControl = new (Solovis.InvDataSelectors as any).CurrencyPairSelectorControl({
            controlHost: selectorControlHostDiv,
            initialValue: this.currentCurrencyPair ? this.currentCurrencyPair : null,
            selectionCallback: function (currencyPair) {
                selectionCallback(currencyPair);
                self._selectionDialog.close();
            },
            cancelCallback: function () {
                self._selectionDialog.close();
            }
        });
        selectorControlHost.setCurrentControl(selectorControl);


        // Determine dialog position.        
        var linkOffset = $(this.selectedCurrencyPairLabel).offset();
        var linkHeight = $(this.selectCurrencyPairLink).outerHeight();
        var dialogPosition = {
            left: linkOffset.left,
            top: linkOffset.top + linkHeight + 5
        };

        var adjustedPosition = Solovis.UI.Dialog.autoAdjustSizeAndPosToViewport(dialogPosition, { width: 350, height: 150 });

        var desiredWidth = Math.min($(window).width() * .8, 250);
        var desiredHeight = Math.min($(window).height() * .8, 300);

        var minWidth = 100;
        var minHeight = 100;

        this._selectionDialog = new Solovis.UI.Dialog({
            container: selectorControlHostDiv,
            ownerDialog: Solovis.UI.Dialog.findContainingDialog(this.container),

            title: false,
            autoOpen: true,
            destroyOnClose: true,
            actions: ["Close"],
            noAnimation: true,
            position: adjustedPosition,
            width: desiredWidth,
            minWidth: minWidth,
            minHeight: minHeight,
            height: desiredHeight,

            buttons: [
                {
                    label: "Clear",
                    click: function () {
                        selectionCallback(null);
                        self._selectionDialog.close();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._selectionDialog.close();
                    }
                }
            ],

            resize: function () {
                var overallHeight = this.getAvailableContentHeight();
                selectorControl.setAvailableHeight(overallHeight);
            },

            activate: function () {
                var overallHeight = this.getAvailableContentHeight();
                selectorControl.setAvailableHeight(overallHeight);
            },

            deactivate: function () {
                self._selectionDialog = null;
            }
        });
    };

})();